export const DEFAULT_FLAT_SHIPPING_FEE = 99;
export const DEFAULT_FREE_SHIPPING_THRESHOLD = 1499;

const toFiniteNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const calculateShippingQuoteFromSubtotal = (
  subtotal,
  {
    flatShippingFee = DEFAULT_FLAT_SHIPPING_FEE,
    freeShippingThreshold = DEFAULT_FREE_SHIPPING_THRESHOLD,
  } = {},
) => {
  const normalizedSubtotal = Math.max(0, toFiniteNumber(subtotal, 0));
  const normalizedFee = Math.max(0, toFiniteNumber(flatShippingFee, DEFAULT_FLAT_SHIPPING_FEE));
  const normalizedThreshold = Math.max(
    0,
    toFiniteNumber(freeShippingThreshold, DEFAULT_FREE_SHIPPING_THRESHOLD),
  );

  const shippingPrice =
    normalizedSubtotal === 0
      ? 0
      : normalizedSubtotal >= normalizedThreshold
        ? 0
        : normalizedFee;

  const qualifiesForFreeShipping = normalizedSubtotal >= normalizedThreshold;
  const amountForFreeShipping = qualifiesForFreeShipping
    ? 0
    : Math.max(0, Number((normalizedThreshold - normalizedSubtotal).toFixed(2)));

  return {
    shippingPrice,
    flatShippingFee: normalizedFee,
    freeShippingThreshold: normalizedThreshold,
    qualifiesForFreeShipping,
    amountForFreeShipping,
    isAddressBased: false,
  };
};
